export const mapGiottoProjectEventToAFType = (giottoEventName) => {
  const map = {
    lutto: 'annuncio',
    anniversario: 'anniversario',
    ringraziamento: 'ringraziamento',
    trigesimo: 'trigesimo',
  };

  if (!map[giottoEventName]) {
    return 'annuncio';
  }

  return map[giottoEventName];
};
